var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatcherVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.832031,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#F2F6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9998 20.4961C41.3827 20.4961 44.1035 20.4961 46.3232 20.6571L40.0139 30.1211H31.4023L37.819 20.4961H37.9998Z",
    fill: "#68953B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3513 23.1809C24.6473 20.8849 28.14 20.5524 34.5085 20.5043L28.0972 30.1211H19.8574C20.1274 26.887 20.7789 24.7533 22.3513 23.1809Z",
    fill: "#68953B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1421 30.1211C55.8721 26.887 55.2206 24.7533 53.6482 23.1809C52.5531 22.0859 51.1858 21.4374 49.3641 21.0535L43.319 30.1211H56.1421Z",
    fill: "#68953B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.7145 32.8711C19.666 34.5921 19.666 36.562 19.666 38.8294C19.666 47.4718 19.666 51.793 22.3509 54.4779C25.0357 57.1627 29.3569 57.1627 37.9993 57.1627C40.4889 57.1627 42.6198 57.1627 44.4564 57.0985C42.8354 56.992 41.7948 56.7085 41.0409 55.9546C39.8327 54.7464 39.8327 52.8018 39.8327 48.9128C39.8327 45.0237 39.8327 43.0791 41.0409 41.8709C42.2491 40.6628 44.1936 40.6628 48.0827 40.6628C51.9718 40.6628 53.9163 40.6628 55.1245 41.8709C55.8785 42.6249 56.1619 43.6657 56.2685 45.2869C56.3327 43.4502 56.3327 41.3191 56.3327 38.8294C56.3327 36.562 56.3327 34.5921 56.2842 32.8711H19.7145Z",
    fill: "#68953B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.082 57C44.1929 57 42.2484 57 41.0402 55.7918C39.832 54.5836 39.832 52.6391 39.832 48.75C39.832 44.8609 39.832 42.9164 41.0402 41.7082C42.2484 40.5 44.1929 40.5 48.082 40.5C51.9711 40.5 53.9157 40.5 55.1238 41.7082C56.332 42.9164 56.332 44.8609 56.332 48.75C56.332 52.6391 56.332 54.5836 55.1238 55.7918C53.9157 57 51.9711 57 48.082 57ZM52.721 46.9723C53.2579 46.4353 53.2579 45.5647 52.721 45.0277C52.184 44.4908 51.3134 44.4908 50.7764 45.0277L46.2487 49.5555L45.3876 48.6944C44.8507 48.1574 43.9801 48.1574 43.4431 48.6944C42.9061 49.2314 42.9061 50.102 43.4431 50.6389L45.2764 52.4723C45.8134 53.0092 46.684 53.0092 47.221 52.4723L52.721 46.9723Z",
    fill: "#68953B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatcherVideos);
export default __webpack_public_path__ + "static/media/watcher_videos.29f2cdf4da02f625beba74a116795f3c.svg";
export { ForwardRef as ReactComponent };